import InputPrimary from "../Input";
import { useTranslation } from "react-i18next";

export default function InputEmail({
  emailPhoneValue,
  setEmailPhoneValue,
  setErrorEmailPhone,
}) {
  const { t } = useTranslation();
  const validateInput = (value) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    const phoneRegex = /^\+?[0-9]\d{9}$/;

    if (value === "" || emailRegex.test(value)) {
      setErrorEmailPhone("");
    } else if (phoneRegex.test(value)) {
      setErrorEmailPhone("");
    } else {
      setErrorEmailPhone("invalid_email_or_phone");
    }
  };
  const handleChange = (e) => {
    const inputValue = e.target.value;
    setEmailPhoneValue(inputValue);
    validateInput(inputValue);
  };

  return (
    <InputPrimary
      type="text"
      placeholder={t("email_or_phone")}
      value={emailPhoneValue}
      onChange={handleChange}
    />
  );
}
